var map = {
	"./address.svg": "be19",
	"./allergenFilters.png": "523b",
	"./angle-down.svg": "b59e",
	"./appStore.png": "0678",
	"./brand-logos/alpro.png": "c71d",
	"./brand-logos/amisa.png": "56be",
	"./brand-logos/beyondmeat.png": "f6d7",
	"./brand-logos/biona.jpg": "8073",
	"./brand-logos/clearspring.jpg": "68a3",
	"./brand-logos/heura.png": "bb50",
	"./brand-logos/hippeas.png": "6d06",
	"./brand-logos/impossible.png": "b80d",
	"./brand-logos/juicymarbles.png": "576c",
	"./brand-logos/just.png": "578f",
	"./brand-logos/loveRaw.png": "9273",
	"./brand-logos/marigold.jpg": "d14b",
	"./brand-logos/meatlessfarm.png": "e690",
	"./brand-logos/mooFree.webp": "fb32",
	"./brand-logos/movingmountains.png": "4789",
	"./brand-logos/mrOrganic.jpg": "9cd9",
	"./brand-logos/oatly.png": "8f43",
	"./brand-logos/omni.png": "d4bc",
	"./brand-logos/oumph.webp": "a020",
	"./brand-logos/rawChocolateCompany.webp": "eaf0",
	"./brand-logos/taifun.png": "43c7",
	"./brand-logos/theMeatlessFarm.png": "98c5",
	"./brand-logos/theToofooCo.png": "c908",
	"./brand-logos/this.webp": "496f",
	"./brand-logos/vego.png": "dd33",
	"./brand-logos/vivera.png": "4c87",
	"./brand-logos/wholefoodearth.png": "a1b8",
	"./call.svg": "180e",
	"./check-mark.svg": "57ad",
	"./cheeseBanner.png": "95a0",
	"./cheeseBanner2.jpg": "fce7",
	"./christmasBanner.jpg": "fc2c",
	"./christmasBannerOld.jpg": "8459",
	"./close.svg": "bf379",
	"./countryList": "5821",
	"./countryList.json": "5821",
	"./currencyList": "9caf",
	"./currencyList.json": "9caf",
	"./easterBannerVK.jpg": "a927",
	"./ethical.png": "2c48",
	"./ethicalDashboard.png": "922e",
	"./exclamation.svg": "89ca",
	"./getEthical.png": "929e",
	"./gluten-free.png": "0545",
	"./googlePayFeature.png": "915a",
	"./googlePlay.png": "d5b4",
	"./halloweenBanner.jpg": "7d15",
	"./happybeansBanner.png": "2225",
	"./header.jpg": "6b2a",
	"./healthyFood.jpg": "5712",
	"./home-page/grocery-shopping-recipes.jpg": "1fcf",
	"./home-page/logo-pink.svg": "41ff",
	"./home-page/resturants-cafes.jpg": "75aa",
	"./home-page/subscriptions.jpg": "aed5",
	"./home-page/travel-experience.jpg": "9f8a",
	"./homepageBanner1.png": "8f77",
	"./homepageBanner2.png": "5cc3",
	"./homepageBanner3.jpg": "749d",
	"./homepageBannerAutumn-old.jpg": "14b8",
	"./homepageBannerAutumn.jpg": "2e06",
	"./homepageBannerCheese-old.jpg": "760e",
	"./homepageBannerCheese.jpg": "e21c",
	"./homepageBannerGifts.jpg": "1213",
	"./homepageBannerJapanese.jpg": "236a",
	"./homepageBottomBanner.webp": "e469",
	"./image1.png": "7081",
	"./image2.png": "289c",
	"./image3.png": "590e",
	"./indianBanner.jpg": "713f",
	"./loader.svg": "6e70",
	"./logo.svg": "9b19",
	"./logoBeta.png": "da06",
	"./mail.svg": "1752",
	"./mailbox.svg": "7aa0",
	"./mainLogo.png": "b5de",
	"./map-marker-light.svg": "aed5c",
	"./meatshopBanner.png": "e3f1",
	"./messagesFeature.png": "1232",
	"./nut-free.png": "cf21",
	"./old.phone.png": "a25c",
	"./peanut-free.png": "2946",
	"./phone.png": "3547",
	"./placeholder-profile.png": "191a",
	"./price-tag.svg": "17b2",
	"./proteinBanner.jpg": "0669",
	"./recipesBanner.png": "4faf",
	"./seafoodBanner.png": "5c7a",
	"./shippingInformation.png": "09b5",
	"./soy-free.png": "f229",
	"./stripe-button.png": "452f",
	"./times-light-white.svg": "762a",
	"./times-light.svg": "afe8",
	"./topDealsBanner.jpg": "86af",
	"./topDealsBanner1.jpg": "1995",
	"./user.svg": "0f62",
	"./uspChilled-old.svg": "bd1e",
	"./uspChilled.svg": "34aa",
	"./uspRosette-old.svg": "54c5",
	"./uspRosette.svg": "b52e",
	"./uspStar-old.svg": "2320",
	"./uspStar.svg": "d219",
	"./uspVan-old.svg": "187f",
	"./uspVan.svg": "2d2f",
	"./veganDayBanner.png": "e4ad",
	"./veganisbetter.png": "d2e1",
	"./vegankind_logo.svg": "bf63",
	"./vegankind_mobile_logo.png": "72ea",
	"./veganuary.jpg": "38fb",
	"./veganuaryBanner.jpeg": "43f5",
	"./veganuaryBanner.png": "7fec",
	"./webfonts/Baskerville-Regular.woff": "fbff",
	"./webfonts/Baskerville-Regular.woff2": "c643",
	"./webfonts/PalmerLakePrint-Regular.otf": "b812",
	"./webfonts/PalmerLakeScript-Regular.otf": "7186",
	"./webfonts/fa-brands-400.eot": "2cbf",
	"./webfonts/fa-brands-400.svg": "ba23",
	"./webfonts/fa-brands-400.ttf": "61c7",
	"./webfonts/fa-brands-400.woff": "ed55",
	"./webfonts/fa-brands-400.woff2": "a369",
	"./webfonts/fa-light-300.eot": "216a",
	"./webfonts/fa-light-300.svg": "7d90",
	"./webfonts/fa-light-300.ttf": "679d",
	"./webfonts/fa-light-300.woff": "ae73",
	"./webfonts/fa-light-300.woff2": "052c",
	"./webfonts/fa-solid.otf": "cf28"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";